var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinicalReception(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.44,7.48m20.9,23.78a1.06,1.06,0,0,1,0,1.48L32.73,54.34a1,1,0,0,1-1.47,0L9.65,32.74a1.06,1.06,0,0,1,0-1.48L31.26,9.66a1,1,0,0,1,1.47,0ZM32,4a2.06,2.06,0,0,0-1.44.59l-26,26a2,2,0,0,0,0,2.88l26,26a2.06,2.06,0,0,0,2.89,0l26-26a2,2,0,0,0,0-2.88l-26-26A2.07,2.07,0,0,0,32,4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34,28a2,2,0,0,0,2,2h2.75A1.25,1.25,0,0,1,40,31.26v1.5A1.25,1.25,0,0,1,38.75,34H36a2,2,0,0,0-2,2v2.75A1.24,1.24,0,0,1,32.76,40h-1.5A1.25,1.25,0,0,1,30,38.76V36a2,2,0,0,0-2-2H25.26A1.25,1.25,0,0,1,24,32.76v-1.5A1.25,1.25,0,0,1,25.26,30H28a2,2,0,0,0,2-2V25.26A1.25,1.25,0,0,1,31.26,24h1.5A1.24,1.24,0,0,1,34,25.26Zm2-8H28a2,2,0,0,0-2,2v3.87a.13.13,0,0,1-.13.13H22a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h3.87a.13.13,0,0,1,.13.13V42a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V38.14a.13.13,0,0,1,.13-.13H42a2,2,0,0,0,2-2V28a2,2,0,0,0-2-2H38.13a.13.13,0,0,1-.13-.13V22a2,2,0,0,0-2-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalReception);
export default __webpack_public_path__ + "static/media/clinicalReception.1d8e6799.svg";
export { ForwardRef as ReactComponent };